import { render, staticRenderFns } from "./RejectQuote.vue?vue&type=template&id=c622d4d6"
import script from "./RejectQuote.vue?vue&type=script&lang=js"
export * from "./RejectQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports